import React from 'react';
import { Box } from '@mui/material';
import styles from './subTitleHeader.module.scss'
import i18next from 'i18next';
import PropTypes from "prop-types";

const SubTitleHeader = (props) => {

    return(
        <Box class={styles.formlabel} data-testid='Subtitle'>{i18next.t(props.title)}</Box>
    )
}

export default SubTitleHeader;
SubTitleHeader.propTypes = {
    title:PropTypes.any
}